export const init = () => {

  // TRACKER 'FOOTER'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.commons.footer);

  // - FOOTER LINKS
  const eventFooterLinks = new AnalyticsSlickEvent('eventFooterLinks', tracker.defaultEvent());
  eventFooterLinks.domContainer = '.container-footer-links .slick-slider';
  eventFooterLinks.domElement = 'a:not(.accordion-section-title)';
  eventFooterLinks.trackDots();
  eventFooterLinks.trackElements({
    vars: {
      selectorParent: '.slick-slide',
      selectorAttribute: 'href',
      selectorTitle: 'h3',
      splitCharacter: '/',
    },
    getLabel($element) {
      const $slide = $element.closest(this.vars.selectorParent);
      const arrLink = $element.attr(this.vars.selectorAttribute).split(this.vars.splitCharacter);

      const menuType = $slide.find(this.vars.selectorTitle).text();
      let pageName = arrLink[arrLink.length-1];

      if (!pageName) {
        if ($element.attr('href').indexOf('recruitment')) pageName = 'join-us';
      }

      return menuType + AnalyticsConstants.concatenator + pageName;
    }
  });
  tracker.addEvent(eventFooterLinks);

  // - FIND US
  const eventFindUs = new AnalyticsClickEvent('eventFindUs', tracker.defaultEvent());
  eventFindUs.domContainer = '.container-footer-newsletter-social';
  eventFindUs.domElement = '.image-social a';
  eventFindUs.params = {attributeToFind: 'class', classToRemove: 'social-icon', strToFind: 'image-', strToReplace: ''};
  eventFindUs.getLabel = function($element) { return $element.clone().removeClass(this.params.classToRemove).attr(this.params.attributeToFind).replace(this.params.strToFind, this.params.strToReplace);};
  tracker.addEvent(eventFindUs);

  // - CHANGE COUNTRY
  const eventChangeCountry = new AnalyticsClickEvent('eventChangeCountry', tracker.defaultEvent());
  eventChangeCountry.domContainer = '.container-footer-countries';
  eventChangeCountry.domElement = 'ul.drop-countries-list li';
  eventChangeCountry.params = {prefix: 'ChangeCountry_'};
  eventChangeCountry.getLabel = function($element) { return this.params.prefix + $element.text();};
  tracker.addEvent(eventChangeCountry);


  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);

};



// WEBPACK FOOTER //
// ./src/analytics/trackers/commons/footer-tracker.js